import { FaPinterest } from "react-icons/fa6";
import { type SocialPlatformBaseSettings } from "./types";

export const pinterestBaseSettings: SocialPlatformBaseSettings = {
  name: "Pinterest",
  icon: FaPinterest,
  fields: {
    title: "required",
    caption: "optional",
    altText: "optional",
    linkAttachment: "optional", // Link associated with the Pin
  },
  limits: {
    caption: 500,
    images: 1,
    videos: 1,
    videoDurationSeconds: 15 * 60, // Max 15 mins
  },
  notes: [
    "Title is prominent on Pinterest.",
    "Each Pin usually links to a source URL.",
  ],
  postTypes: {
    pin: {}, // Default type is a Pin
  },
};
